import { render, staticRenderFns } from "./headerSubject.vue?vue&type=template&id=8fc95d20&scoped=true&"
import script from "./headerSubject.vue?vue&type=script&lang=js&"
export * from "./headerSubject.vue?vue&type=script&lang=js&"
import style0 from "../style/index.css?vue&type=style&index=0&id=8fc95d20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fc95d20",
  null
  
)

export default component.exports